<template>
	<div>
		<v-card flat color="transparent">
			<v-card-text>
				<v-row align="center">
                    <v-col cols="12" md="3" xl="3" class="mx-0 pr-0 pr-sm-1 px-0 py-lg-0 py-1" >
                        <alternativeAutocompleteOne
                            :items="types"
                            :valueInput="selectedType"

                            @valueChange="(v) => {selectedType = v}"
                            @onChange="(v) => {index()}"

                            :label="'Tipo'"
                            classesContainer="width-auto"
                        ></alternativeAutocompleteOne>
                    </v-col>
					<v-col cols="12" md="3" lg="2"  xl="2" class="mx-0  px-0 py-lg-0 mb-0">
                        <alternativeDatePickerRangeVCalendar
                            :valueInput="{start: dateRange.start_date, end: dateRange.end_date}"
                            @valueChange="(v) => {dateRange.start_date = v.start; dateRange.end_date = v.end; index(); delete serverErrors['date']}"
                            label="Fechas"
                        ></alternativeDatePickerRangeVCalendar>

					</v-col>

					<v-spacer></v-spacer>
					<v-col  cols="12" md="5"  xl="4" class="mx-0  mt-0 py-4">
                        <v-row justify="end">
                            <iconButton :props="pdfBtnData" class="mr-2 mr-md-2 mb-3 mb-md-0">
                                <template slot="imgIcon">
                                    <img :src="pdfIcon" width="24" :class="pdfBtnData.disabled ? `filter-grey` : `filter-grey-darken-3`">
                                </template>
                            </iconButton>
                            <iconButton :props="exportBtnData"></iconButton>
                        </v-row>
					</v-col>
				</v-row>
				<v-row>
					<v-col class="mx-0 px-0">
						<v-card class="index-card">
                            <v-card-title class="body-1 font-weight-bold">
                                <v-col>
                                    <v-row class="primary">
                                        <v-col cols="12" lg="6" class="py-1 ">
                                           <v-row>
                                                <v-col class="text-lg-start text-center">
                                                    <span>TOTAL (MXN):</span>
                                                </v-col>
                                                <v-col class="text-lg-end text-center">
                                                    <span>{{mxnTotalReport}}</span>
                                                </v-col>
                                           </v-row>
                                        </v-col>
                                        <v-col cols="12" lg="6" class="py-1">
                                           <v-row>
                                                <v-col class="text-lg-start text-center">
                                                    <span>TOTAL (USD):</span>
                                                </v-col>
                                                <v-col class="text-lg-end text-center">
                                                    <span>{{usdTotalReport}}</span>
                                                </v-col>
                                           </v-row>
                                        </v-col>


                                    </v-row>
                                </v-col>
                            </v-card-title>
                            <v-card-text >
                                <datatable :options="options" :props="tableProps" @methodHandler="method_handler" @handleOptions="handleOptions">

                                </datatable>
                            </v-card-text>
                        </v-card>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>


	</div>
</template>
<script>
import pdfIcon from '../../../assets/pdf_icon_2.svg';
import Utils from '../../../helpers/Utils';
import PageStateManager from '../../../helpers/PageStateManager';
export default {
    data(){
		return {
            pdfIcon: pdfIcon,
            options: JSON.parse(PageStateManager.getState(this.$router.history.current.path, 'optionsIndexTable'))??{},
            total: 10,
			search: '',
            selectedID: '',
            mxnTotalReport: '$0.00',
            usdTotalReport: '$0.00',

            types: [
                {text: 'Ingreso', value: 'INCOME'},
                {text: 'Egreso', value: 'EXPENSE'},
            ],
            selectedType: PageStateManager.getState(this.$router.history.current.path, 'selectedType')??'',

            dateRange: {
                start_date: PageStateManager.getState(this.$router.history.current.path, 'start_date')??Utils.getStartDate(),
                end_date: PageStateManager.getState(this.$router.history.current.path, 'end_date')??new Date().toISOString().split('T')[0]
            },
			serverErrors: {},
			tableProps: {
				headers: [
					{
						text: 'Fecha',
						align: 'left',
						value: 'date',

						class: 'table-b-border black--text'
					},
                    {
						text: 'Semana',
						align: 'center',
						value: 'week_number',
						class: 'table-b-border black--text'
					},
					{
						text: 'Cliente',
						align: 'left',
						value: 'name',

						class: 'table-b-border black--text'
					},
                    {
						text: 'Folio',
						align: 'center',
						value: 'folio',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Folio pagado',
						align: 'center',
						value: 'folio_int',

						class: 'table-b-border black--text'
					},
                    {
						text: 'Importe',
						align: 'right',

						value: 'total_payment',
						class: 'table-b-border black--text'
					},
                    {
						text: 'IVA',
						align: 'right',

						value: 'iva',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Total',
						align: 'right',

						value: 'total',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Divisa',
						align: 'right',

						value: 'currency',
						class: 'table-b-border black--text'
					},

				],
				items: [],
				search: '',
				loading: PageStateManager.getState(this.$router.history.current.path, 'selectedType') ? true : false,
                elevation: '0'
			},


            exportBtnData: {
                hasTooltip:true,
                tooltip: 'Exportar excel',
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                icon: "mdi-microsoft-excel",
                iconClass: "",
				block: false,
                loading: false,
                disabled:true,
                click: ()=>{this.export();}
            },

            pdfBtnData: {
                disabled:true,
                hasTooltip:true,
                tooltip: 'Exportar PDF',
                customIcon:true,
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                icon: "mdi-file-pdf-box",
                iconClass: "",
				to: "",
				block: false,
                loading: false,
                click: ()=>{this.pdf();}
            },


		}
	},

    watch: {
        [`selectedType`]() {
           this.watchSelectedType();
        },
        [`dateRange.start_date`]() {
            this.options.page = 1;
            PageStateManager.setState(this.$router.history.current.path, 'start_date', this.dateRange.start_date);

        },
        [`dateRange.end_date`]() {
            this.options.page = 1;
            PageStateManager.setState(this.$router.history.current.path, 'end_date', this.dateRange.end_date);

        }
    },

	mounted(){
        // window.addEventListener('resize', this.onResize, { passive: true });
        // this.onResize();
        this.watchSelectedType();
        this.index();
	},

    methods: {
        watchSelectedType()
        {
            this.options.page = 1;
            PageStateManager.setState(this.$router.history.current.path, 'selectedType', this.selectedType);
            this.pdfBtnData.disabled = true;
            this.exportBtnData.disabled = true;
            if(this.selectedType != "" && this.selectedType != null && this.selectedType != undefined){
                this.pdfBtnData.disabled = false;
                this.exportBtnData.disabled = false;
            }
        },
        onResize () {

            if(window.innerWidth <= 960){
                this.exportBtnData.block = true;
                this.pdfBtnData.block = true;

            }
            else{

                this.exportBtnData.block = false;
                this.pdfBtnData.block = false;
            }
        },
        method_handler(object){
            console.log(object);
			this[object.methodName](object.parameters)
		},
        handleOptions(object){
            object.options[`search`] = this.tableProps.search;
			//console.log(object.options);
			this.options = object.options;
            PageStateManager.setState(this.$router.history.current.path, 'optionsIndexTable', JSON.stringify(this.options));
			// this.index();
		},
        trySearch(val){
            this.tableProps.search = val;
            this.options.page = 1;
            this.index();
        },
		index() {
            if(this.selectedType == '' || this.selectedType == null || this.dateRange.start_date == '' || this.dateRange.end_date == '')
                return;
            //change header by type
            this.tableProps.headers[2].text = 'Cliente'
            if(this.selectedType == 'EXPENSE'){
                this.tableProps.headers[2].text = 'Proveedor'
            }
			this.tableProps.loading = true;
            // this.mxnTotalReport = Utils.currencyFormat(0, 'MXN');
            // this.usdTotalReport = Utils.currencyFormat(0, 'USD');
            this.tableProps.items = [];
			//call api
			this.$api.report.reportPaymentComplement(this.$store.state.business, this.selectedType,this.dateRange.start_date, this.dateRange.end_date)
				.then((resp) =>{
					//console.log(resp);



                    this.mxnTotalReport = Utils.currencyFormat(resp.data.summary.total.mxn, 'MXN');
                    this.subtotalReport = Utils.currencyFormat(resp.data.summary.total.usd, 'USD');
					this.tableProps.items = resp.data.data.map((x) => {

						x.total_payment = Utils.currencyFormat(x.total_payment??0, x.currency);
						x.iva = Utils.currencyFormat(x.iva??0, x.currency);
						x.total = Utils.currencyFormat(x.total??0, x.currency);
                        x.date = Utils.globalDateFormat(x.date);
                        x.name = x.provider_name??x.customer_name;
                        x.folio = x.folio??'-';
                        x.folio_int = x.folio_int??'-';
						return x;
					});
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
					this.tableProps.loading = false;
				})
			;

		},



        export()
        {
            this.exportBtnData.loading = true;
            this.$store.state.loading = true;
            this.$api.report.exportReportPaymentComplement(this.$store.state.business, this.selectedType,this.dateRange.start_date, this.dateRange.end_date)
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `payment_complement_${this.selectedType}_${this.dateRange.start_date}_${this.dateRange.end_date}.xlsx`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.exportBtnData.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },

        pdf()
        {
            this.pdfBtnData.loading = true;
            this.$store.state.loading = true;
            this.$api.report.pdfReportPaymentComplement(this.$store.state.business, this.selectedType,this.dateRange.start_date, this.dateRange.end_date)
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `payment_complement_${this.selectedType}_${this.dateRange.start_date}_${this.dateRange.end_date}.pdf`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.pdfBtnData.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        }

    }
}
</script>